import React, { useState } from "react";
import { Box, Checkbox, FormControlLabel, Tooltip, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import CheckBoxOutlineBlankOutlinedIcon from "@mui/icons-material/CheckBoxOutlineBlankOutlined";
import CheckBoxOutlinedIcon from "@mui/icons-material/CheckBoxOutlined";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { Theme } from "@mui/material/styles";

const useStyles = makeStyles<Theme, CustomCheckBoxProps>((theme) => ({
  checkbox: {
    color: (props) => (props.disabled ? "#00000061" : theme.palette.primary.main),
    background: (props) => (props.disabled ? "transparent" : theme.palette.primary.light),
  },
}));

interface CustomCheckBoxProps {
  label: string;
  checked: boolean | undefined;
  indeterminate?: boolean;
  tooltip?: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  emitDataLayer?: (checked: boolean) => void;
}

export const CustomCheckBox = React.forwardRef(
  (props: CustomCheckBoxProps, ref: React.Ref<HTMLInputElement>) => {
    const classes = useStyles(props);
    const [hover, setHover] = useState(false);
    const { disabled = false, emitDataLayer } = props;
    const Component = (
      <FormControlLabel
        ref={ref}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        control={
          <Checkbox
            icon={
              hover ? (
                disabled ? (
                  <CheckBoxIcon className={classes.checkbox} />
                ) : (
                  <CheckBoxOutlinedIcon className={classes.checkbox} />
                )
              ) : (
                <CheckBoxOutlineBlankOutlinedIcon />
              )
            }
            checkedIcon={<CheckBoxOutlinedIcon />}
            indeterminate={props.indeterminate}
            checked={props.checked}
            onChange={(e) => {
              if (e.target.checked && emitDataLayer) {
                emitDataLayer(true);
              } else if (!e.target.checked && emitDataLayer) {
                emitDataLayer(false);
              }
              props.onChange(e);
            }}
            disabled={disabled}
          />
        }
        label={
          <Typography sx={{ color: `${disabled && "#00000061"}` }} variant="body1">
            {props.label}
          </Typography>
        }
      />
    );

    return (
      <Box {...props}>
        {props.tooltip ? (
          <Tooltip placement="right" arrow describeChild title={props.tooltip}>
            {Component}
          </Tooltip>
        ) : (
          Component
        )}
      </Box>
    );
  }
);
